<template>
  <div class="receiving-address">
    <navbar :isHiddenlogin="true"></navbar>
    <step-bar :step="2"></step-bar>
    <div class="address-container">
      <div class="selected-address">
        <span>选择收货地址：</span>
        <button class="add-btn" @click="showDialog = true">新增收货地址</button>
      </div>
      <div class="address-list">
        <template v-if="addressList.length">
          <div class="address-item" v-for="(item, index) in addressList" :key="index" @click="setDefault(index)">
            <div class="col name">{{ item.consignee }}</div>
            <div class="col address invoice-container-left">{{ item.province }}{{ item.city }}{{ item.area }}{{
              item.street }}</div>
            <div class="col phone">{{ item.phone }}</div>
            <div class="col radio-col">
              <label class="custom-radio">
                <input type="radio" :checked="index === selectIndex" @change="setDefault(index)"
                  name="address-default" />
                <span class="radio-mark">
                  <svg v-if="index === selectIndex" width="22" height="22" viewBox="0 0 22 22">
                    <circle cx="11" cy="11" r="10" fill="#1677ff" />
                    <polyline points="6,12 10,16 16,7" fill="none" stroke="#fff" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg v-else width="22" height="22" viewBox="0 0 22 22">
                    <circle cx="11" cy="11" r="10" fill="#fff" stroke="#d9d9d9" stroke-width="2" />
                  </svg>
                </span>
              </label>
            </div>
          </div>
          <div class="footer">
            <button class="next-btn" @click="next">下一步&nbsp;&nbsp;&nbsp;开具发票</button>
          </div>
        </template>
        <div v-else class="empty-address">
          <p>您还没有添加收货地址</p>
          <button class="add-btn" @click="showDialog = true">新增收货地址</button>
        </div>
      </div>
    </div>


    <!-- 新增收货地址弹窗 -->
    <div class="dialog-mask" v-if="showDialog">
      <div class="dialog">
        <div class="form-row">
          <label><span class="required">*</span> 收货人：</label>
          <input v-model="form.name" type="text" placeholder="请输入收货人姓名..." />
        </div>
        <div class="form-row">
          <label><span class="required">*</span> 手机号：</label>
          <input v-model="form.phone" type="text" placeholder="请输入手机号..." maxlength="11" />
        </div>
        <div class="form-row">
          <label><span class="required">*</span> 所在地区：</label>
          <el-cascader ref="cascaderRef" v-model="form.address" :props="cascaderProps" placeholder="请选择省/市/区..."
            style="width: 100%;flex: 1;"></el-cascader>
        </div>
        <div class="form-row">
          <label><span class="required">*</span> 详细地址：</label>
          <input v-model="form.street" type="text" placeholder="请输入详细地址..." />
        </div>
        <div class="form-row">
          <label>是否默认：</label>
          <input type="checkbox" v-model="form.isDefault" />
          <span>作为默认收货地址</span>
        </div>
        <div class="dialog-btns">
          <button class="cancel-btn" @click="showDialog = false">取消</button>
          <button class="save-btn" @click="saveAddress">保存</button>
        </div>
      </div>
    </div>

    <!-- 不可配送提示 -->
    <div v-if="deliveryDialog" class="no-invoice-dialog-mask">
      <div class="no-invoice-dialog">
        <div class="no-invoice-title">温馨提示</div>
        <div class="no-invoice-content">该地区暂不支持配送</div>
        <button class="no-invoice-btn" @click="deliveryDialog = false">我已知悉</button>
      </div>
    </div>
  </div>
</template>
<script>
import navbar from '@/components/nav.vue'
import stepBar from '@/components/step-bar.vue'
import { getProvince, getCity, getArea, address, receivingAddress, searchPortal } from '@/api/api'
import { data } from 'jquery';
let id = 0;
export default {
  name: "index",
  components: {
    navbar,
    stepBar
  },
  data() {
    return {
      addressList: [],
      defaultIndex: 0,//默认
      selectIndex: 0,//选择
      showDialog: false,
      form: {
        name: '',
        phone: '',
        street: '',
        isDefault: 0,
        address: '',
        province: '',
        city: '',
        area: '',
      },
      deliveryDialog: false,
      cascaderProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            // 加载省份
            getProvince().then(res => {
              if (res.code === 200) {
                const nodes = res.data.map(item => ({
                  value: item.code,
                  label: item.name,
                  leaf: false
                }))
                resolve(nodes)
              } else {
                resolve([])
              }
            })
          } else if (node.level === 1) {
            // 加载城市
            getCity(node.data.value).then(res => {
              if (res.code === 200 && res.data.length > 0) {
                const nodes = res.data.map(item => ({
                  value: item.code,
                  label: item.name,
                  leaf: false
                }))
                resolve(nodes)
              } else {
                resolve([])
              }
            })
          } else if (node.level === 2) {
            // 加载区域
            const provinceCode = node.parent.data.value
            const cityCode = node.data.value
            getArea(provinceCode, cityCode).then(res => {
              if (res.code === 200 && res.data.length > 0) {
                const nodes = res.data.map(item => ({
                  value: item.code,
                  label: item.name,
                  leaf: true
                }))
                resolve(nodes)
              } else {
                resolve([])
              }
            })
          } else {
            resolve([])
          }
        }
      }
    }
  },
  computed: {

  },
  methods: {
    getAddressList() {
      receivingAddress().then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.addressList = res.data;
        }
      })
    },
    setDefault(index) {
      this.selectIndex = index;
    },
    saveAddress() {
      if (!this.form.name || !this.form.phone || !this.form.address || !this.form.street) {
        this.$message.warning('请填写完整信息')
        return;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.form.phone)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      const cascaderNode = this.$refs.cascaderRef.getCheckedNodes()[0];
      if (!cascaderNode || !cascaderNode.isLeaf) {
        this.$message.warning('请选择完整的所在地区');
        return;
      }
      // 提取省市区name
      let province = '', city = '', area = '';
      if (cascaderNode && cascaderNode.pathLabels) {
        province = cascaderNode.pathLabels[0] || '';
        city = cascaderNode.pathLabels[1] || '';
        area = cascaderNode.pathLabels[2] || '';
      }
      this.form.province = province;
      this.form.city = city;
      this.form.area = area;
      var params = {
        "consignee": this.form.name,
        "phone": this.form.phone,
        "province": province,
        "city": city,
        "area": area,
        "street": this.form.street,
        "isDefault": this.form.isDefault ? '1' : '0',
      }
      address(params).then((res) => {
        if (res.code == 200) {
          this.getAddressList();
          this.showDialog = false;
          // 重置表单
          this.form = { name: '', phone: '', address: [], street: '', isDefault: 0 };
        }
      })
    },
    next() {
      var params = {
        "endProv": this.addressList[this.selectIndex].province,
        "endCity": this.addressList[this.selectIndex].city,
        "endTown": this.addressList[this.selectIndex].area,
        "endAddress": this.addressList[this.selectIndex].street,
      }
      // 获取上一个页面传递的商品信息
      const goods = JSON.parse(this.$route.query.goods || '[]');
      // 获取选中的地址ID（如果未选择则使用默认地址）
      const selectedAddressId = this.addressList[this.selectIndex].id;
      // 构建传递给下一个页面的数据
      const data = {
        addressId: selectedAddressId,
        // goods: goods
      };
      // 将数据传递给下一个页面
      this.$router.push({
        path: '/Invoice',
        query: {
          data: JSON.stringify(data)
        }
      });
      // searchPortal(params).then((res) => {
      //   if (res.data.success && res.data.orgStopSend == 'N') {  //N 没停运可配送 Y 停运不可配送

      //   } else {
      //     this.deliveryDialog = true;
      //   }
      // })

    }
  },
  mounted() {
    this.getAddressList();
  }
}
</script>
<style scoped>
.receiving-address {
  min-height: 100vh;
  height: 100%;
  background-image: url('@/assets/images/home/container-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding-bottom: 100px;
}

.address-container {
  margin-top: 30px;
  width: var(--main-width);
  margin: 0 auto;
}

.selected-address {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  align-items: center;
}

.selected-address span {
  font-weight: bold;
}

.address-list {
  margin: 30px 0;
  /* background:rgba(235, 241, 248, 0.8);*/
  background: rgba(246, 248, 225048, 0.8);
  border-radius: 5px;
  padding: 20px 0 60px 0;
}

.address-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  font-size: 20px;
  color: #222;
  border: none;
  box-shadow: none;
  border-bottom: 1px solid #bdbdbd;
  transition: background 0.2s, color 0.2s, border 0.2s;
  /* font-weight: bold; */
  margin: 0 40px;
}

.address-item:last-child {
  border-bottom: 1.5px solid #bdbdbd;
}

.col {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 64px;
  padding: 0 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  position: relative;
}

.invoice-container-left {
  justify-content: left !important;
}


.col:not(:first-child)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 24px;
  background: #bdbdbd;
  margin: 0;
}

.name {
  width: 80px;
  flex-shrink: 0;
}

.address {
  min-width: 700px;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.phone {
  width: 180px;
  flex-shrink: 0;
}

.radio-col {
  width: 80px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding-right: 0;
  padding-left: 0;
}

.custom-radio {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.custom-radio input[type="radio"] {
  display: none;
}

.radio-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.add-btn {
  background: #2765D5;
  color: #fff;
  border: none;
  padding: 8px 28px;
  border-radius: 5px;
  font-size: 16px;
  margin-right: 30px;
  cursor: pointer;
}

.footer {
  margin-top: 60px;
  text-align: center;
}

.next-btn {
  background: #2765D5;
  color: #fff;
  border: none;
  padding: 8px 28px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
}

.dialog-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog {
  background: #fff;
  border-radius: 16px;
  padding: 50px 60px 40px 60px;
  min-width: 550px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: var(--fontSize);
}

.form-row label {
  width: 80px;
  text-align: right;
  margin-right: 30px;
}

.form-row input[type="text"] {
  flex: 1;
  height: 34px;
  border: 1.5px solid #e0e0e0;
  border-radius: 6px;
  padding: 0 16px;
}

.form-row input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.dialog-btns {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-top: 30px;
}

.cancel-btn,
.save-btn {
  background: #2765D5;
  color: #fff;
  border: none;
  padding: 8px 40px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

.cancel-btn {
  background: #fff;
  border: 2px solid #2765D5;
  opacity: 0.8;
  color: #2765D5;
}

.empty-address {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0 0 0;
}

.empty-address p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.no-invoice-dialog-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-invoice-dialog {
  background: #fff;
  border-radius: 18px;
  min-width: 400px;
  padding: 40px 36px 36px 36px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-invoice-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 18px;
  text-align: center;
}

.no-invoice-content {
  font-size: 16px;
  color: #333;
  margin-bottom: 32px;
  text-align: center;
}

.no-invoice-btn {
  background: #2865D4;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 60px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}
</style>